import * as React from "react";
// librerias
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-grid-system";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../components/layout/Header";
import { BiLinkExternal } from "react-icons/bi";
import { AiOutlineBgColors } from "react-icons/ai";
import { FiSettings } from "react-icons/fi";

// components
import colors from "../../assets/colors/colors";
import ListSections from "../../components/Restaurant/admin/ListSections";
import ConfigProfile from "../../components/Restaurant/admin/ConfigProfile";
import ModalFremium from "../../components/utils/ModalFremium";
import ModalQRCode from "../../components/Restaurant/admin/ModalQRCode";

import LoaderPage from "../../components/utils/LoaderPage";

import { getDatabase, ref, onValue } from "firebase/database";
import MenuStyles from "components/Restaurant/admin/MenuStyles";

interface StyledInterface {
  color: any;
  background: string;
}

export default function Admin() {
  const [bussine, setBussineData] = React.useState<any>(null);

  const [modalconfig, setmodalconfig] = React.useState<any>(false);
  const [modalfremium, setModalFremium] = React.useState<boolean>(false);
  const [modalqr, setModalQr] = React.useState<boolean>(false);
  const [isLoader, setLoader] = React.useState(false);
  const [idconfig, setIdConfig] = React.useState<number>(0);

  React.useEffect(() => {
    getDataRestaurant();
  }, []);

  const getDataRestaurant = async () => {
    setLoader(true);
    const idLocal: any = localStorage.getItem("localId");
    let data;
    const realtime = getDatabase();
    const starCountRef = ref(realtime, "restaurants/" + idLocal);
    onValue(starCountRef, (snapshot) => {
      if (snapshot.exists()) {
        data = snapshot.val();
        setBussineData(data);

        console.log(data, "bussine");
        // getDataSections(data.menu);
        setLoader(false);
      } else {
      }
    });
  };

  const handleModalConfig = () => {
    let open = !modalconfig;
    if (!open) getDataRestaurant();
    setmodalconfig(open);
  };

  const openModalFremium = () => {
    let open = !modalfremium;
    setModalFremium(open);
  };

  const openModalQR = () => {
    let open = !modalqr;
    setModalQr(open);
  };
  const handleConfig = (id: number) => {
    setIdConfig(id);
  };

  return (
    <>
      <Header data={bussine} />

      {bussine && (
        <HeaderNew>
          <div className="logo">
            <img src={bussine.logo} alt="" />
          </div>
          <div className="content">
            <h1>{bussine.name}</h1>
            <h5>{bussine.description}</h5>
          </div>
        </HeaderNew>
      )}

      {isLoader ? (
        <LoaderPage />
      ) : (
        <ContentAdmin color={colors} background={""}>
          {/* {idconfig === 0 && ( */}
          <Container>
            <ContentConfig>
              <Row>
                <Col xs={12}>
                  <div className="content">
                    <span>
                      <BiLinkExternal />
                    </span>{" "}
                    {bussine && (
                      <a
                        href={`/menu/${bussine.id}`}
                        target={"_blank"}
                        className="viewlive"
                        style={{ width: "100%" }}
                      >
                        Menu en vivo
                      </a>
                    )}
                  </div>
                </Col>
              </Row>
            </ContentConfig>
          </Container>
          <Container>
            {bussine && (
              <>
                <section className="section_main">
                  <h3> Administrar menú</h3>
                  <ListSections
                    data={bussine}
                    openModalFremium={openModalFremium}
                  />
                </section>
              </>
            )}
          </Container>
          <div className="w-100 text-center">
            {bussine && (
              <>
                {!bussine.premium && (
                  <button
                    className="btn btn-success my-2"
                    onClick={() => openModalFremium()}
                  >
                    Desbloquear funcionalidades🔓
                  </button>
                )}
              </>
            )}
          </div>
          {modalconfig && (
            <ConfigProfile
              closeModal={handleModalConfig}
              data={bussine && bussine}
            />
          )}
        </ContentAdmin>
      )}
      {modalfremium && <ModalFremium closeFremium={openModalFremium} />}
      <Toaster position="bottom-center" reverseOrder={false} />
    </>
  );
}

const HeaderNew = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 1em;

  .logo {
    padding: 1em 0;
    img {
      width: 75px;
      height: 75px;
      border-radius: 100px;
    }
  }

  .content {
    h1 {
      font-size: 2em;
      font-weight: bold;
      color: #130f40;
    }
  }
`;

const ContentConfig = styled.div`
  width: 100%;
  padding: 1em 0;
  .content {
    width: 100%;
    padding: 0.5em 2em;
    background: #2c3e50;
    font-size: 1.2em;
    color: white;
    font-weight: bold;
    margin: 0.5em 0;
    cursor: pointer;
    border-bottom: 1px solid #00000025;
    border-radius: 12px;
    a {
      text-decoration: none;
      color: white;
    }
    span {
      padding-right: 0.5em;
    }
  }
`;

const FixedBottomPremium = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 8vh;
  background: #2c3e50b3;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px #00000050;
`;

const ContentHeader = styled.div<StyledInterface>`
  width: 100%;
  min-height: 22vh;
  background-image: url(${(props) => props.background});
  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;
  position: relative;
  background-position: center;
  .filter {
    width: inherit;
    min-height: inherit;
    background: #00000039;
  }
  .content {
    width: 100%;
    position: absolute;
    bottom: -17em;
    /* border-bottom: 2px solid ${(props) => props.color.white01}; */
    padding: 1em 1em;
    .viewlive {
      font-size: 1.3em;
      border-radius: 0 !important;
    }
    .info {
      width: 100%;
    }
    h2 {
      font-weight: bold;
      color: ${(props) => props.color.black};
    }
    p {
      color: ${(props) => props.color.gray};
      font-weight: 400;
      font-size: 16px;
    }
    .contentLogo {
      width: 130px;
      height: 130px;
      border-radius: 160px;
      border: 5px solid white;
      bacgkround: white;
      img {
        width: 100%;
        height: 120px;
        border-radius: 160px;
        object-fit: cover;
      }
    }
  }
`;

const ContentAdmin = styled.div<StyledInterface>`
  min-height: 90vh;
  position: relative;
  background: white;
  h2 {
    font-weight: bold;
  }
  h3 {
    font-weight: bold;
  }
  .section_main {
    padding: 2em 0;
  }
  main {
    width: 100%;
    min-height: 100vh;
    border-top: 1px solid ${(props) => props.color.citylight};
    padding-top: 1em;
    overflow-x: hidden;
    h3,
    h4 {
      font-weight: 500;
      color: ${(props) => props.color.black};
    }
  }

  .form {
    div {
      padding: 0.5em 0;
    }
  }
  label {
    font-size: 1em;
    font-weight: 500;
  }
  input {
    display: block;
    font-size: 1em;
    border: 2px solid ${(props) => props.color.white01};
    &:focus {
      border: 2px solid ${(props) => props.color.blue};
    }
  }
  input[type="file"] {
    display: none;
  }
  .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
  }
`;
